import React, {Component} from 'react';
import axios from 'axios';
import {  withRouter } from "react-router-dom";
import auth0Client from '../Auth';
import {ToastContainer, ToastStore} from 'react-toasts';
import {SERVER_URL}  from '../Constants';
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import BootstrapTable from 'react-bootstrap-table-next';
//import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
//import paginationFactory from 'react-bootstrap-table2-paginator';
import 'react-phone-number-input/style.css'
//import { timeStamp } from 'console';




const labelPurchaseTypes =[
    {
        name: 'Guest (The guest will recieve an email request to purchase a shipping label)',
        value: 'guest'
    },
    {
        name: 'Room Charge or Comp (Guest will not receive a request for payment)',
        value: 'house'
    },

]



const columns = [


     { dataField: 'provider_image_200', text: 'Carrier', formatter: imageFormat },
     { dataField: 'servicelevel',classes:'text-primary',formatter: serviceLevel,  text: 'Service',   textAlign: 'left', headerStyle: {width:'300px'} },
    { dataField: 'amount',sort: true, text: 'Amount',  textAlign: 'right', classes:'text-primary',headerStyle: (colum, colIndex) => {return { width: '120px', textAlign: 'right' }; } },
    { dataField: 'currency',sort: true, text: 'currency',  textAlign: 'right', classes:'text-primary',headerStyle: (colum, colIndex) => {return { width: '120px', textAlign: 'right' }; } },
    

     ];
     
     function serviceLevel(cell, row){
      let testDesc = (row.test) ? ' (Test)' : '' ;
       if (row.servicelevel){

            return(row.servicelevel.name) + testDesc
       }else if (row.duration_terms){
            return row.duration_terms + testDesc
       }else{
            return "---";
       }
    }
    
  function imageFormat(cell, row){
    if (row.provider_image_200){
        return (
            <img  src={row.provider_image_200} style={{width: '35px', height:'25px'}}  alt={row.provider} />
        )
    }else{
      return (
        <img  src='../default-placeholder.png' width={25} height={25} alt={row.provider} />
    )
    }
}


const typeOfContent = [
    'DOCUMENTS',
    'GIFT',
    'SAMPLE',
    'MERCHANDISE',
    'HUMANITARIAN_DONATION',
    'RETURN_MERCHANDISE',
    'OTHER', 
]
var currencyCodes = ["AED", "AFN", "ALL", "AMD", "ANG", "AOA", "ARS", "AUD", "AWG", "AZN", "BAM", "BBD", "BDT", "BGN", "BHD", "BIF", "BMD", "BND", "BOB", "BOV", "BRL", "BSD", "BTN", "BWP", "BYR", "BZD", "CAD", "CDF", "CHE", "CHF", "CHW", "CLF", "CLP", "CNY", "COP", "COU", "CRC", "CUC", "CUP", "CVE", "CZK", "DJF", "DKK", "DOP", "DZD", "EGP", "ERN", "ETB", "EUR", "FJD", "FKP", "GBP", "GEL", "GHS", "GIP", "GMD", "GNF", "GTQ", "GYD", "HKD", "HNL", "HRK", "HTG", "HUF", "IDR", "ILS", "INR", "IQD", "IRR", "ISK", "JMD", "JOD", "JPY", "KES", "KGS", "KHR", "KMF", "KPW", "KRW", "KWD", "KYD", "KZT", "LAK", "LBP", "LKR", "LRD", "LSL", "LTL", "LVL", "LYD", "MAD", "MDL", "MGA", "MKD", "MMK", "MNT", "MOP", "MRO", "MUR", "MVR", "MWK", "MXN", "MXV", "MYR", "MZN", "NAD", "NGN", "NIO", "NOK", "NPR", "NZD", "OMR", "PAB", "PEN", "PGK", "PHP", "PKR", "PLN", "PYG", "QAR", "RON", "RSD", "RUB", "RWF", "SAR", "SBD", "SCR", "SDG", "SEK", "SGD", "SHP", "SLL", "SOS", "SRD", "SSP", "STD", "SYP", "SZL", "THB", "TJS", "TMT", "TND", "TOP", "TRY", "TTD", "TWD", "TZS", "UAH", "UGX", "USD", "USN", "USS", "UYI", "UYU", "UZS", "VEF", "VND", "VUV", "WST", "XAF", "XAG", "XAU", "XBA", "XBB", "XBC", "XBD", "XCD", "XDR", "XFU", "XOF", "XPD", "XPF", "XPT", "XTS", "XXX", "YER", "ZAR", "ZMW"];

class ReturnWizard2 extends Component {
    constructor(props) {
      super(props);
      //console.log(this.props.match.params.lostItemId);
      this.state = {
            curPage: 1,
            venueId:auth0Client.getActiveVenuedId(),
            claimDate:new Date(),
            shipDate: new Date(), // default to today
            lostItemId: (this.props.lostItemId) ? this.props.lostItemId : '',
            claimId:(this.props.claim) ? this.props.claim.id : '',
            status: 'O',
            firstName: (this.props.claim) ? (this.props.claim.firstName) : '',
            lastName: (this.props.claim) ? (this.props.claim.lastName) : '',
            phone:(this.props.claim) ? (this.props.claim.phone) : '',
            email:(this.props.claim) ? (this.props.claim.email) : '',
            details:'',
            claimSource:'INTERNAL',
            pickupDate:'',
            disabled :false,
            showSuccess: false,
            showLostItemPicker: false,
            shippingAddress:(this.props.claim && this.props.claim.shippingAddress) ? (this.props.claim.shippingAddress) : '',
            shippingAddress2:(this.props.claim && this.props.claim.shippingAddress2) ? (this.props.claim.shippingAddress2) : '',
            shippingCity:(this.props.claim && this.props.claim.shippingCity) ? (this.props.claim.shippingCity) : '',
            shippingPostalCode:(this.props.claim && this.props.claim.shippingPostalCode) ? (this.props.claim.shippingPostalCode) : '',
            shippingState:(this.props.claim && this.props.claim.shippingState) ? (this.props.claim.shippingState) : '',
            shippingCountry:(this.props.claim && this.props.claim.shippingCountry) ? (this.props.claim.shippingCountry) : '',
            locationLost:'',
            showOpenShipment:false,
            displayStep1:true,
            displayStep2:false,
            displayStep3:false,
            displayStep4:false,
            displayStep5:false,
           
            currentStep :1,

            widthInInches : 10.0,
            heightInInches : 10.0,
            lengthInInches : 10.0,
            weightInOunces : 0,
            weightInLbs: 0,

            typeOfContent: 'RETURN_MERCHANDISE',
            certify :true,
            certifiedSigner:'',
            customDescription:props.shortDescription,
            customQuantity:1,
            customValue: 1,
            customCcy:'USD',
            customCountryOfOrigin:'US',
            isInternational: false,
            name: '',
            active:true,
            publishId:'',
            venueDescription:'',
            fromAddress: '',
            fromAddress2: '',
            fromCity: '',
            fromState: '',
            fromPostalCode: '',
            fromCountry: '',
            shippoRateResults:{
                rates:[]
            },
            loading: false,
            selectedRate:{},
            parcelTemplateName:'own_packaging',
            insuranceAmt :0,
            insuranceCurrency: 'USD',
            shippoMessages: [],
            smsphonenumber:'',

            additionalPackingFee:0,
            defaultPackingFee:0,
            selectedShipperName:'',
            hasFedEx: false,
            hasUSPS: false,
            hasUPS: false,
            hasDHL: false,
            enableFeeOverride:false,
            feeOverrideAmount:0.00,
            eTipUrl:'',
            enableEtip:false,
            eTipUsers:[],
            masterTipUrl:'',
            
            shippoErrors:[],
            selectedRows:[],
            valueAmount:0,
      }

      this.rowEvents = {
        onClick: (e, row, rowIndex) => {
          
          //this.props.history.push('/LostItem/' + row.id);
          //console.log( ' ' + `clicked on row with index: ${rowIndex}`);
          this.setState({
            selectedRate : row,
            selectedShipperName: row.provider,
            selectedRows:[row.object_id]
          });
          //this.toStep4();
      
        },
        
      };
    }

    componentDidMount(){
        //
        // load the venue address
        axios.get(`${SERVER_URL}/venue/` + auth0Client.getActiveVenuedId(),{
            headers: { 'Authorization': `Bearer ${auth0Client.getIdToken()}` }
          }).then((res)=>{
            const venue = res.data;
            this.setState({
                name: venue.name,
                active:venue.active,
                publishId:venue.publishId,
                venueDescription:venue.venueDescription,
                fromAddress: venue.shippingAddress,
                fromAddress2: venue.shippingAddress2,
                fromCity: venue.shippingCity,
                fromState: venue.shippingState,
                fromPostalCode: venue.shippingPostalCode,
                fromCountry: venue.shippingCountry,
                customCountryOfOrigin:venue.shippingCountry,
                defaultPackingFee:venue.defaultPackingFee,
                additionalPackingFee:venue.defaultPackingFee, // always set this since the item
                disabled:false,
                hasFedEx : (venue.hasFedEx),
                hasUSPS:(venue.hasUSPS),
                hasUPS:(venue.hasUPS),
                hasDHL:(venue.hasDHL),
                enableFeeOverride: (venue.enableFeeOverride),
                hotelShippingFee:venue.hotelShippingFee,
                internationalShippingFee:venue.internationalShippingFee,
                feeOverrideAmount:venue.hotelShippingFee,
                enableEtip:venue.enableEtip,
                 masterTipUrl:venue.eTipUrl


            }, ()=>{
              this.loadTipReceipienents();
            });
          
          }).catch((e)=>{  
            //console.log("error " + e )
            ToastStore.error("An error occured.  Please try again. error: " + e.message);
          });
      
        
    }
   
    loadTipReceipienents=async()=>{
      try {
        if (this.state.enableEtip){
          const users = (await axios.get(`${SERVER_URL}/Users/tipreceipients`,{
            headers: { 'Authorization': `Bearer ${auth0Client.getIdToken()}`,
            'venueId' : auth0Client.getActiveVenuedId()
           }
          })).data;
  
          //  console.log(users);
    
          this.setState({
              eTipUsers : users
              
          });
        }else{
          console.log('Tipping is not enabled');
        }
      
      } catch (e) {
          ToastStore.error("An error occured. Please try again. error: " + e.message);
    
      }
    }
    /*
      NAME:  renderETipSection

    */
    renderETipSection=()=>{
        if (this.state.enableEtip){
          return (
            <div className='form-row'>
              <hr/>
                <div className='col-6'>
                    <h5>Tip Receipient:</h5> 
                </div>
            <div className='col-6'>
                  <select
                      disabled={this.state.disabled}
                      type="text"
                      onChange={this.handleInputTipChange}  //important! 
                      name="eTipUrl"
                      className="custom-select"
                      placeholder=""
                      value= {this.state.eTipUrl}
                    > 
                    <option key='' value=''>None</option>
                    <option key='-1' value={this.state.masterTipUrl}>* Main Account</option>
                          {(this.state.eTipUsers) && this.state.eTipUsers.map(item => (
                            <option key={item.etipId} value={item.etipId} id={item.id}>
                             {item.lastName + ',' + item.firstName}
                            </option>
                          ))}
              </select>   
            </div>
            </div>
          )
        }
      }

    handleInputTipChange=(event)=>{
      const target = event.target;
      const value = target.value;
      console.log('eTipUrl:' + value)
      this.setState({
        eTipUrl:value
      })
  }


    handlePhoneChange=(event)=>{

      const target = event.target;
      const value = target.value;

        this.setState({
            phone:value,
            smsphonenumber:value
        })
    }

   

    handleInternationalInputChange =(event)=>{
      const target = event.target;
      const value = target.type === 'checkbox' ? target.checked : target.value;
      const name = target.name;
      let feeOverrideAmount=0.00;
     
     
      feeOverrideAmount= (value) ? this.state.internationalShippingFee : this.state.hotelShippingFee;
      this.setState({
        feeOverrideAmount:feeOverrideAmount,
        [name]: value,
      });
    
    }
    
    handleInputChange=(event) =>{
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
       
       
        this.setState({
          [name]: value,
         
        }, );
      
      }
  
      validate=async()=>{

        // check the short Description
        if (!this.state.lastName) {ToastStore.error('invalid or missing Last Name'); return false;}
        // check long description
        if (!this.state.firstName) {ToastStore.error('invalid or First Name'); return false;}
        
        //console.log('Claim status' + this.state.status)
        if ((this.state.status!=='O' && this.state.status!=='A') && this.state.lostItemId===''){
    
          ToastStore.error('CLAIM EXCEPTION: Cannot set claim status to anything other then Open or Archive until linked to a lost item');
          return false;
    
      }
    
        return true;
    
    
      }
      onShipDateChange = date => this.setState({ shipDate :date })



      validateForShip=()=>{

        // check the short Description
        if (!this.state.lastName) {ToastStore.error('Missing Last Name'); return false;}
        // check long description
        if (!this.state.firstName) {ToastStore.error('Missing First Name'); return false;}
        // check Email
        if (!this.state.email) {ToastStore.error('Missing Email'); return false;}
        // check ship address
        if (!this.state.shippingAddress) {ToastStore.error('Missing Shipping Address'); return false;}
        // check ship city
        if (!this.state.shippingCity) {ToastStore.error('Missing Shipping City'); return false;}
        // check ship State
        if (!this.state.shippingState && this.state.shippingCountry==='US') {ToastStore.error('Missing Shipping State'); return false;}
        // check ship postal
        if (!this.state.shippingPostalCode) {ToastStore.error('Missing Shipping Postal Code'); return false;}
        // check ship postal
        if (!this.state.shippingCountry) {ToastStore.error('Missing Shipping Country'); return false;}
  
        // Validate for a valid email address format
        if (!this.state.email || !this.state.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
          ToastStore.error('Invalid email address. Check for missing characters or spaces.');
          return false;
        }
       
        axios.post(`${SERVER_URL}/Shipping/ValidateShipping`, {
         
          firstName: this.state.firstName,
          lastName: this.state.lastName,
          email:this.state.email,
          shippingAddress: this.state.shippingAddress,
          shippingAddress2: this.state.shippingAddress2,
          shippingCity: this.state.shippingCity,
          shippingState: this.state.shippingState,
          shippingPostalCode: this.state.shippingPostalCode,
          shippingCountry:this.state.shippingCountry,
          isInternational: this.state.isInternational,
          
      }, {
          headers: { 
            'Authorization': `Bearer ${auth0Client.getIdToken()}`,
            'venueId': auth0Client.getActiveVenuedId()
          
          }
        }).then((res)=>{
         
          if (res.status!==200){
                
              ToastStore.error("An error in the shipping validation occured was found: " + res.statusText);

            }else{
             // console.log(res.data);
              let validationObj = res.data;
              // in test mode for international, there is no validation_results
              if (validationObj.validation_results.is_valid===undefined){
                // test mode, return true
                return true;
              }

              if (validationObj.validation_results.is_valid===false){
                let errorMessage  = '';
                validationObj.validation_results.messages.map(err => {
                  errorMessage += err.text + '\n';
                  return err;
                })
                
                alert(errorMessage);
                return false;
              }else{
                let address = validationObj.street1 + ' ' + validationObj.street2 + ' ' +  validationObj.city + ' ' + validationObj.state + ' ' + validationObj.zip + ' ' + validationObj.country;
                if (window.confirm("The shipping carriers validated the address as : \n " + address + '\n Use this address instead? ')){
                    this.setState({
                      shippingAddress : validationObj.street1 ,
                      shippingAddress2: validationObj.street2 ,
                      shippingCity: validationObj.city,
                      shippingState: validationObj.state,
                      shippingPostalCode:validationObj.zip,
                      shippingCountry: validationObj.country
                    });
                    return true;
                }else{
                    // ignore
                    return true;
                }




              }
              

            }
            
        })
        .catch ((e)=>{
             ToastStore.error(e.message);
             return false;
      })

      
  
     
  
  
    }
  
    validateDimensions=()=>{
        // dimensions
        //console.log("Width:" + Number.parseFloat(this.state.widthInInches));
        if (!this.state.widthInInches){ToastStore.error('Missing Width Dimension'); return false;};
        if (!this.state.heightInInches){ToastStore.error('Missing Height Dimension'); return false;};
        if (!this.state.lengthInInches){ToastStore.error('Missing Length Dimension'); return false;};
        //if (!this.state.weightInOunces){ToastStore.error('Missing a valid weight in Oz.  If there is no OZ, then enter 0'); return false;};

        if (Number.parseFloat(this.state.widthInInches)===0 || Number.parseFloat(this.state.widthInInches)< 0){ToastStore.error('Missing Width Dimension'); return false;}
        if (Number.parseFloat(this.state.heightInInches)===0 || Number.parseFloat(this.state.heightInInches)< 0){ToastStore.error('Missing Height Dimension'); return false;}
        if (Number.parseFloat(this.state.lengthInInches)===0 || Number.parseFloat(this.state.lengthInInches)< 0){ToastStore.error('Missing Length Dimension'); return false;}

        // If the ounces are zero and lbs is 0 = total of nothing will be incorrect
        if (Number.parseFloat(this.state.weightInOunces)===0 && Number.parseFloat(this.state.weightInLbs)===0){ToastStore.error('Missing Weight. Please enter a valid weight.'); return false;}
        if (Number.parseFloat(this.state.weightInOunces)< 0 || Number.parseFloat(this.state.weightInLbs)< 0){ToastStore.error('Missing Weight, must be a positive number'); return false;}

        return true;
    }

    
    validateForInternationalShipping=()=>{
      // Item Dec 
      if (!this.state.customDescription){ToastStore.error('Missing customs item description'); return false;}
      if (!this.state.customCountryOfOrigin){ToastStore.error('Missing customs country of origin'); return false;}
      if (!this.state.certifiedSigner){ToastStore.error('Missing customs certified signer'); return false;}
      if (!this.state.customQuantity){ToastStore.error('Missing customs quantity'); return false;}
      if (!this.state.customValue){ToastStore.error('Missing customs value'); return false;}
      // Check if the length of the customDescription is less then 50
      if (this.state.customDescription.length > 50){ToastStore.error('Customs description is too long.  Must be less then 50 characters'); return false;}
      
      return true;
    }



    printShipping=(url)=>{
          window.open(url);
    }
  

    closeWizard=()=>{
      if (this.props.onClose){
        this.props.onClose();
      }
    }

    getShippingOptions=()=>{

        this.setState({loading:true, shippoMessages:[]});
        axios.post(`${SERVER_URL}/Shipping/getshippingoptions`, {
            claimId: (this.props.claim)? (this.props.claim.id) : '',   
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            email:this.state.email,
            phone: this.state.phone,
            lostItemId:this.state.lostItemId,
            claimSource : 'INTERNAL',
            venueId: auth0Client.getActiveVenuedId(),
            shipDate: Date.parse(this.state.shipDate),
            shippingAddress: this.state.shippingAddress,
            shippingAddress2: this.state.shippingAddress2,
            shippingCity: this.state.shippingCity,
            shippingState: this.state.shippingState,
            shippingPostalCode: this.state.shippingPostalCode,
            shippingCountry:this.state.shippingCountry,
            
            widthInInches : this.state.widthInInches,
            heightInInches : this.state.heightInInches,
            lengthInInches : this.state.lengthInInches,
            weightInOunces : this.state.weightInOunces,
            weightInLbs: this.state.weightInLbs,
            valueAmount: this.state.valueAmount,
            typeOfContent: this.state.typeOfContent,
            certify :this.state.certify,
            certifiedSigner:this.state.certifiedSigner,
            customDescription:this.state.customDescription,
            customQuantity:this.state.customQuantity,
            customValue: this.state.customValue,
            customCcy:this.state.customCcy,
            customCountryOfOrigin:this.state.customCountryOfOrigin,
            isInternational: this.state.isInternational,
            billTypeCode: this.state.billTypeCode, // customer or house
            parcelTemplateName: this.state.parcelTemplateName,
            insuranceAmt :this.state.insuranceAmt,
            insuranceCurrency : this.state.insuranceCurrency,
            smsphonenumber: this.state.smsphonenumber
        }, {
            headers: { 
              'Authorization': `Bearer ${auth0Client.getIdToken()}`,
              'venueId': auth0Client.getActiveVenuedId()
            
            }
          }).then((res)=>{  
           console.log(res.data);
             if (res.response && res.response.data){
              // check if there are address validation errors
              let validationErrorMessages =[];
              if (res.response.data.address_to.validation_results && res.response.data.address_to.validation_results.length >0){
                let validationResults = res.response.data.address_to.validation_results;  
                if (!validationResults[0].is_valid){
                  validationErrorMessages = validationResults[0].messages;
                }
              }  
              // display validation errors first
              console.log(res.response);
              this.setState({
                  shippoRateResults:[],
                  shippoErrors:(validationErrorMessages.length >0) ? validationErrorMessages : ((res.response.data.messages)? res.response.data.messages: []),
                  loading:false
                })
             }else{

              this.setState({
                shippoRateResults:res.data,
                shippoErrors:[],
                shippoMessages:(res.data.messages)? res.data.messages: [],
                loading:false
              })
             }
            
            //console.log(res.data);
            //  if (res.data.messages && res.data.messages.length >0){
            //    for(var i=0; i < res.data.messages.length; i++){
            //      ToastStore.warning(res.data.messages[i].text,7000);
            //    }
              
              //}


          }).catch ((e)=>{
            if (e.response){
              console.log(e.response)
            }
            console.error(e);
            this.setState({
                showAlert:true,
                disabled: false,
                error:e,
                loading:false
      
            })
                 if (e) { ToastStore.error(e.message) }
             })
    }

    purchase=async()=>{
        // have a valid item to purchase?
        if (!await this.validate()){
            return;
          }
      
          this.setState({
            disabled: true,
          });
          axios.post(`${SERVER_URL}/Shipping/purchaseinhouselabel`, {
            claimId: (this.props.claim)? (this.props.claim.id) : '',   
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            email:this.state.email,
            phone: this.state.phone,
            lostItemId:this.state.lostItemId,
            claimSource : 'INTERNAL',
            venueId: auth0Client.getActiveVenuedId(),
            shipDate: Date.parse(this.state.shipDate),
            shippingAddress: this.state.shippingAddress,
            shippingAddress2: this.state.shippingAddress2,
            shippingCity: this.state.shippingCity,
            shippingState: this.state.shippingState,
            shippingPostalCode: this.state.shippingPostalCode,
            shippingCountry:this.state.shippingCountry,
            
            widthInInches : this.state.widthInInches,
            heightInInches : this.state.heightInInches,
            lengthInInches : this.state.lengthInInches,
            weightInOunces : this.state.weightInOunces,
            weightInLbs: this.state.weightInLbs,
            valueAmount: this.state.valueAmount,
            typeOfContent: this.state.typeOfContent,
            certify :this.state.certify,
            certifiedSigner:this.state.certifiedSigner,
            customDescription:this.state.customDescription,
            customQuantity:this.state.customQuantity,
            customValue: this.state.customValue,
            customCcy:this.state.customCcy,
            customCountryOfOrigin:this.state.customCountryOfOrigin,
            isInternational: this.state.isInternational,
            billTypeCode: this.state.billTypeCode, // customer or house
            rate:this.state.selectedRate,
            shippoRateResults: this.state.shippoRateResults,
            parcelTemplateName: this.state.parcelTemplateName,
            insuranceAmt : this.state.insuranceAmt,
            insuranceCurrency: this.state.insuranceCurrency,
            smsphonenumber: this.state.smsphonenumber
        }, {
            headers: { 
              'Authorization': `Bearer ${auth0Client.getIdToken()}`,
              'venueId': auth0Client.getActiveVenuedId()
            
            }
          }).then((res)=>{
            if (res.status!==200){
                 // console.log(res);
                ToastStore.error("An error occured during the request for the shipping label from the customer: "+ res.response.data);
                this.setState({
                   
                    showAlert:false,
                    disabled: false,
                   
                });

              }else{
              
                  //console.log(res);
                  this.setState({
                    currentStep :5,
                    showAlert:false,
                    disabled: false,
                    showSuccess: false,
                    displayStep4:false,
                    displayStep6:true,
                   
                });
                  //alert(res.data);
                  return res.data;

              
               
               

              }
          });

    }

    sendShippingRequest=async()=>{
        if (!await this.validate()){
            return;
          }
      
          this.setState({
            disabled: true,
          });
      
           console.log('Saving:' +   this.state.eTipUrl);

       
          axios.post(`${SERVER_URL}/Shipping/CreateClaimAndRequestShipping`, {
            claimId: (this.props.claim)? (this.props.claim.id) : '',   
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            email:this.state.email,
            phone: this.state.phone,
            lostItemId:this.state.lostItemId,
            claimSource : 'INTERNAL',
            venueId: auth0Client.getActiveVenuedId(),
            shipDate: Date.parse(this.state.shipDate),
            shippingAddress: this.state.shippingAddress,
            shippingAddress2: this.state.shippingAddress2,
            shippingCity: this.state.shippingCity,
            shippingState: this.state.shippingState,
            shippingPostalCode: this.state.shippingPostalCode,
            shippingCountry:this.state.shippingCountry,
            
            widthInInches : this.state.widthInInches,
            heightInInches : this.state.heightInInches,
            lengthInInches : this.state.lengthInInches,
            weightInOunces : this.state.weightInOunces,
            weightInLbs: this.state.weightInLbs,
            valueAmount: this.state.valueAmount,
            typeOfContent: this.state.typeOfContent,
            certify :this.state.certify,
            certifiedSigner:this.state.certifiedSigner,
            customDescription:this.state.customDescription,
            customQuantity:this.state.customQuantity,
            customValue: this.state.customValue,
            customCcy:this.state.customCcy,
            customCountryOfOrigin:this.state.customCountryOfOrigin,
            isInternational: this.state.isInternational,
            billTypeCode: this.state.billTypeCode, // customer or house
            parcelTemplateName: this.state.parcelTemplateName,
            insuranceAmt : this.state.insuranceAmt,
            insuranceCurrency: this.state.insuranceCurrency,
            test: 'test',
            smsphonenumber: this.state.smsphonenumber,
            additionalPackingFee: this.state.additionalPackingFee,
            feeOverrideAmount:this.state.feeOverrideAmount,
            eTipUrl: this.state.eTipUrl
        }, {
            headers: { 
              'Authorization': `Bearer ${auth0Client.getIdToken()}`,
              'venueId': auth0Client.getActiveVenuedId()
            
            }
          }).then((res)=>{
            if (res.status!==200){
                  
                ToastStore.error("An error occured during the request for the shipping label from the customer.  Support will review the logs.  Please try again.");
              }else{
                if (this.state.billTypeCode=== 'house'){
                 // console.log(res);
                  this.setState({
                   
                    showAlert:false,
                    disabled: false,
                    showSuccess: false,
                    displayStep4:false,
                    displayStep6:true,

                });
                 // alert(res.data);
                  return res.data;

                }else{
                  ToastStore.success('Request sent Successfully!');
                  this.setState({
                    currentStep :4,
                    showAlert:false,
                    disabled: false,
                    showSuccess: true,
                    displayStep3:false,
                    displayStep4:false,
                    displayStep5:true
    
                })
                }
               
               

              }
               
          
            
              if (this.props.refreshParent){
                this.props.refreshParent();
              }
          })
          .catch ((e)=>{
            console.error(e);
            this.setState({
                showAlert:true,
                disabled: false,
                error:e,
      
            })
            if (e) { ToastStore.error(e.message) }
      
        })









    }

    
    
  renderStepOne=()=>{
      return(
        <div className="form-group" style={{width:'700px', height:'600px'}}>
                     
        <br/>
        <div className='form-row'>
        <div className='col'>
                               <label htmlFor="billTypeCode" className='text-primary'> Label Purchase Type:</label>
                                 <select
                                   disabled={this.state.disabled}
                                   type="text"
                                   onChange={this.handleInputChange}
                                   name="billTypeCode"
                                   className="custom-select"
                                   placeholder=""
                                   value= {this.state.billTypeCode}
                                 > 
                                 {labelPurchaseTypes.map(item => (
                                   <option key={item.value} value={item.value}>
                                     {item.name}
                                   </option>
                                 ))}
                                 </select>   
                               </div>
        </div>

<hr/>
        <div className='form-row'>
            <div className='col-6'>
                  <label htmlFor="firstName" className='text-danger'><b>First Name (required):</b></label>
                              <input
                                disabled={this.state.disabled}
                                type="text"
                                onChange={this.handleInputChange}
                                name="firstName"
                                className="form-control"
                                placeholder=""
                                value= {this.state.firstName}
                              />
            </div>
            <div className='col-6'>
                            <label htmlFor="lastName" className='text-danger'><b>Last Name (required):</b></label>
                              <input
                                disabled={this.state.disabled}
                                type="text"
                                onChange={this.handleInputChange}
                                name="lastName"
                                className="form-control"
                                placeholder=""
                                value= {this.state.lastName}
                              />
              </div>

      </div>

           <div className='form-row'>
             <div className='col-6'>
                               
                             <label htmlFor="email" className='text-danger'><b>Email (required):</b></label>
                               <input
                                 disabled={this.state.disabled}
                                 type="email"
                                 onChange={this.handleInputChange}
                                 name="email"
                                 className="form-control"
                                 placeholder=""
                                 value= {this.state.email}
                               />
             </div>
             <div className='col-6'>
                               
                               <label htmlFor="phone" className='text-danger'><b>Phone (required):</b></label>
                                 <input
                                   disabled={this.state.disabled}
                                   type="phone"
                                   onChange={this.handlePhoneChange}
                                   name="phone"
                                   className="form-control"
                                   placeholder=""
                                   value= {this.state.phone}
                                 />
               </div>
              

             </div>

      <div className='form-row'>
                 <div className='col-6'>
                 <label htmlFor="shippingAddress" className='text-primary'>Shipping Address {(this.state.billTypeCode==='house')? '(required)' : ''}:</label>
                             <input
                               disabled={this.state.disabled}
                               type="text"
                               name="shippingAddress"
                               onChange={this.handleInputChange}
                               className="form-control"
                               placeholder=""
                               value= {this.state.shippingAddress}
                             />
                 </div>

                  <div className='col-6'>
                  <label htmlFor="exampleInputEmail1" className='text-primary'>Shipping Address2 :</label>
                            <input
                              disabled={this.state.disabled}
                              type="text"
                              name="shippingAddress2"
                              onChange={this.handleInputChange}
                              className="form-control"
                              placeholder=""
                              value= {this.state.shippingAddress2}
                            />
                  </div>
       </div>
       <div className='form-row'>
                               <div className='col-4'>
                                   <label htmlFor="shippingCity" className='text-primary'> City (optional):</label>
                                 <input
                                   disabled={this.state.disabled}
                                   type="text"
                                   onChange={this.handleInputChange}
                                   name="shippingCity"
                                   className="form-control"
                                   placeholder=""
                                   value= {this.state.shippingCity}
                                 />    

                               </div>
                               <div className='col'>
                               <label htmlFor="shippingState" className='text-primary'> State / Prov.: {(this.state.billTypeCode==='house')? '(required)' : ''} </label>
                               <input
                                   disabled={this.state.disabled}
                                   type="text"
                                   onChange={this.handleInputChange}
                                   name="shippingState"
                                   className="form-control"
                                   placeholder=""

                                   value= {this.state.shippingState}
                                 />   
                                 
                               
                               </div>
                               <div className='col-4'>
                                   <label htmlFor="shippingPostalCode" className='text-primary'> Postal Code {(this.state.billTypeCode==='house')? '(required)' : ''}:</label>
                                 <input
                                   disabled={this.state.disabled}
                                   type="text"
                                   onChange={this.handleInputChange}
                                   name="shippingPostalCode"
                                   className="form-control"
                                   placeholder=""

                                   value= {this.state.shippingPostalCode}
                                 />   

                               </div>
           </div>




            <div className='form-row'>
                 <div className='col-6'>
                    <label htmlFor="shippingCountry" className='text-primary'> Country {(this.state.billTypeCode==='house')? '(required)' : ''}:</label>
                                          <select
                                            disabled={this.state.disabled}
                                            type="text"
                                            onChange={this.handleInputChange}
                                            name="shippingCountry"
                                            className="custom-select"
                                            placeholder=""
                                            value= {this.state.shippingCountry}
                                          > 
                                          {isoCountries.map(item => (
                                            <option key={item.ccode} value={item.ccode}>
                                              {item.cname}
                                            </option>
                                          ))}
                                          </select>   

                </div>
                <div className='col-6'>
                <br/>
                  <label className="col-form-label col-form-label-sm">(NOTE: Inter-EU may not be classified as int'l.  Check with carrier.) </label>
 
                  </div>
                   
             </div>   

           
           <div className='form-row'>
           <div className='col-10'>
                            <br/>                
                  `     <input
                                disabled={this.state.disabled}
                                type="checkbox"
                                onChange={this.handleInternationalInputChange}
                                className="form-check-input"
                                placeholder=""
                                checked = {this.state.isInternational}
                                name='isInternational'
                              />
                              <label className="text-danger"><b>INTERNATIONAL Shipping </b> -Check if international  </label>
                  </div>`
                
           </div>
         


<br/>
           <div className='form-row '>
               <div className='col-4 text-center'>
                  
             
                </div>
                <div className='col-4 text-center'>
                    <button
                    disabled={this.state.disabled || (this.state.id===-1)}
                    className="btn btn-outline-primary btn-sm"
                    onClick={() => {this.closeWizard()}}>
                    Close
                    </button>
             
                </div>
                <div className='col-4 text-right'>
                    <button
                    disabled={this.state.disabled || (this.state.id===-1)}
                    className="btn btn-outline-success btn-sm"
                    onClick={() => {this.toStep2()}}>
                    Next
                    </button>
             
                </div>
              
             </div>

   </div>
      )
    }

    toStep2=()=>{
        
        // check long description
        if (!this.state.firstName) {ToastStore.error('Missing First Name'); return false;}
        // check the short Description
        if (!this.state.lastName) {ToastStore.error('Missing Last Name'); return false;}
        // check Email
        if (!this.state.email) {ToastStore.error('Missing Email'); return false;}
        // If this is on the house, the shipping information must be specified, it will be needed for shipping
        if (this.state.billTypeCode==='house'){
            // check ship address
            if (!this.state.shippingAddress) {ToastStore.error('Missing shipping Address'); return false;}
            // check ship city
            if (!this.state.shippingCity) {ToastStore.error('Missing shipping City'); return false;}
            // check ship State if in the US
            if (!this.state.shippingState && this.state.shippingCountry==='US') {ToastStore.error('Missing shipping State'); return false;}
            // check ship postal
            if (!this.state.shippingPostalCode) {ToastStore.error('Missing shipping Postal Code'); return false;}
            // Phone number is required
            if (!this.state.phone) {ToastStore.error('Missing phone number'); return false;}
        }
          // Validate for a valid email address format
          if (!this.state.email || !this.state.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
            ToastStore.error('Invalid email address. Check for missing characters or spaces.');
            return false;
          }
        //console.log('International:' + this.state.isInternational);
        //console.log('Phone:' + this.state.Phone);

        if (!this.state.phone){ToastStore.error('Missing phone number for international and some domestic shipping carriers like FedEx'); return false;}
        this.setState({
            currentStep :2,
            displayStep1:false,
            displayStep2:true,
            displayStep3:false
        });

    }
    toStep2GuestBill=()=>{

       
       // check the short Description
       if (!this.state.lastName) {ToastStore.error('Missing Last Name'); return false;}
       // check long description
       if (!this.state.firstName) {ToastStore.error('Missing First Name'); return false;}
       // check Email
       if (!this.state.email) {ToastStore.error('Missing Email'); return false;}
       // check ship address
       if (!this.state.shippingAddress) {ToastStore.error('Missing shipping Address'); return false;}
       // check ship city
       if (!this.state.shippingCity) {ToastStore.error('Missing shipping City'); return false;}
       // check ship State
       if (!this.state.shippingState && this.state.shippingCountry==='US') {ToastStore.error('Missing shipping State'); return false;}
       // check ship postal
       if (!this.state.shippingPostalCode) {ToastStore.error('Missing shipping Postal Code'); return false;}
       // check ship postal
       if (!this.state.shippingCountry) {ToastStore.error('Missing shipping Country'); return false;}
 
       
      
       axios.post(`${SERVER_URL}/Shipping/ValidateShipping`, {
        
         firstName: this.state.firstName,
         lastName: this.state.lastName,
         email:this.state.email,
         shippingAddress: this.state.shippingAddress,
         shippingAddress2: this.state.shippingAddress2,
         shippingCity: this.state.shippingCity,
         shippingState: this.state.shippingState,
         shippingPostalCode: this.state.shippingPostalCode,
         shippingCountry:this.state.shippingCountry,
         isInternational: this.state.isInternational,
         
     }, {
         headers: { 
           'Authorization': `Bearer ${auth0Client.getIdToken()}`,
           'venueId': auth0Client.getActiveVenuedId()
         
         }
       }).then((res)=>{
        
         if (res.status!==200){
               
             ToastStore.error("An error in the shipping validation occured was found: " + res.statusText);

           }else{
            
             let validationObj = res.data;
             // in test mode for international, there is no validation_results
             if (validationObj.validation_results.is_valid===undefined){
               // test mode, return true
               this.setState({
                currentStep :2,
                displayStep1:false,
                displayStep2:true,
                displayStep3:false
              });
               return true;
             }

             if (validationObj.validation_results.is_valid===false){
               let errorMessage  = '';
               validationObj.validation_results.messages.map(err => {
                 errorMessage += err.text + '\n';
                 return err;
               })
               
               alert(errorMessage);
               return false;
             }else{
               let address = validationObj.street1 + ' ' + validationObj.street2 + ' ' +  validationObj.city + ' ' + validationObj.state + ' ' + validationObj.zip + ' ' + validationObj.country;
               if (window.confirm("The shipping carriers validated the address as : \n " + address + '\n Use this address instead? ')){
                   this.setState({
                     shippingAddress : validationObj.street1 ,
                     shippingAddress2: validationObj.street2 ,
                     shippingCity: validationObj.city,
                     shippingState: validationObj.state,
                     shippingPostalCode:validationObj.zip,
                     shippingCountry: validationObj.country
                   });
                   this.setState({
                      currentStep :2,
                      displayStep1:false,
                      displayStep2:true,
                      displayStep3:false
                    });
               }else{
                   // ignore
                  // Dont move forward, not valid
                  return false;
               }




             }
             

           }
           
       })
       .catch ((e)=>{
            ToastStore.error(e.message);
            return false;
     })
      

    }


    toStep3=()=>{

        if (this.validateDimensions()===true){
           
            this.setState({
                currentStep :3,
                displayStep4:false,
                displayStep2:false,
                displayShippingOptions:false,
                displayStep3:true,
               

            })
        }
    }
    toStep4=async()=>{
        if (this.state.isInternational===false || (this.state.isInternational && this.validateForInternationalShipping())){
            //console.log('ok to go');
            this.setState({
                currentStep :4,
                
                displayStep3:false,
                displayStep4:true,
                displayShippingOptions:false,

            })
        }
           
           
           
       
    }
    toStep5=async()=>{
        if (!window.confirm('BOUNTE will send a request to purchase a shipping label to the guest.  Click ok to continue')){
          return;
        }
        await this.sendShippingRequest();
      
      }
    
    toStep6=async()=>{

      let results = await this.sendShippingRequest();
      if (results && results.shipmentId){
        this.setState({
          currentStep :5, // leave as 5
          displayStep5:false,
          displayStep6:true
         })
      }

      
    }


    toStep1=()=>{
        this.setState({
         currentStep :1,
         displayStep1:true,
         displayStep2:false
        })
     }

     handleParcelSelection=(event)=>{
      
      try {
      const target = event.target;
      const value = target.type === 'checkbox' ? target.checked : target.value;
      const name = target.name;
  
      this.setState({
        [name]: value
      });
      let optionText = target.options[target.selectedIndex].text;
      let start = optionText.indexOf('(')+1;
      let end = optionText.indexOf(')')-1;
      if (start > 0){
        let sizeString = optionText.substr(start,end).replace('in', '');
        let sizeArray = sizeString.split('x');
        this.setState({
          lengthInInches: parseFloat(sizeArray[0].trim()), //length
          widthInInches :parseFloat(sizeArray[1].trim()), // width
          heightInInches: parseFloat(sizeArray[2].trim()), // height

        });
       
        };
        if (target.selectedIndex===0){
          // Own Packaing, set default packing fee
          this.setState({
              additionalPackingFee:this.state.defaultPackingFee
          })
        }else{
          this.setState({
            additionalPackingFee:0
        })
    }
    }catch(e){
      
    }
      

      
     }

     loadShippingOptions=()=>{

     }



    renderStepTwo=()=>{
        return(
            <div className="alert alert-dismissible alert-secondary" style={{width:'700px', height:'600px'}}>
            <div className="row">

                    <div className='col-12' style={{textAlign:'center'}}> 
                        <h3 >Parcel Details</h3>
                       
                        
                    </div>
                    
                    
                    
            </div>

            <div className="row mb-2">
                   
                     <div className='col-12' style={{textAlign:'center'}}>
                     <img src='../dimensions.png' alt='' style={{width:'150px', height:'150px'}} />
                     </div>
                     
             </div>   
            
             <div className='form-row mb-2'>
                    <div className='col-4'>
                    <label htmlFor="exampleInputEmail1" className='text-danger'>Ship Date:</label>
                  
                  <DatePicker
                      className="form-control"
                      onChange={this.onShipDateChange}
                      name="shipDate"
                      selected={this.state.shipDate}
                    />
                    </div>
                    <div className='col-8'>
              <label htmlFor="parcelSize" className='text-primary'> Parcel Size:</label>
                                 <select
                                   disabled={this.state.disabled}
                                   type="text"
                                   onChange={this.handleParcelSelection}
                                   name="parcelTemplateName"
                                   className="custom-select"
                                   placeholder=""
                                   value= {this.state.parcelTemplateName}
                                 > 
                                <option id="ember2057" value="own_packaging" className="ember-view x-option">Own packaging</option>
                                
                                {this.state.hasFedEx &&
                                    <optgroup label="FedEx"><option id="ember2078" value="FedEx_Box_10kg" class="ember-view x-option">FedEx® 10kg Box(15.8 x 12.9 x 10.2 in)</option>
                                      <option id="ember2080" value="FedEx_Box_25kg" class="ember-view x-option">FedEx® 25kg Box (54.8 x 42.1 x 33.5 in)</option>
                                      <option id="ember2082" value="FedEx_Envelope" class="ember-view x-option">FedEx® Envelope (12.5 x 9.5 x 0.8 in)</option>
                                      <option id="ember2084" value="FedEx_Box_Extra_Large_1" class="ember-view x-option">FedEx® Extra Large Box-X1 (11.9 x 11.0 x 10.8 in)</option>
                                      <option id="ember2086" value="FedEx_Box_Extra_Large_2" class="ember-view x-option">FedEx® Extra Large Box-X2 (15.8 x 14.1 x 6.0 in)</option>
                                      <option id="ember2088" value="FedEx_XL_Pak" class="ember-view x-option">FedEx® Extra Large Pak (17.5 x 20.8 x 2.0 in)</option>
                                      <option id="ember2090" value="FedEx_Box_Large_1" class="ember-view x-option">FedEx® Large Box -L1 (17.5 x 12.4 x 3.0 in)</option>
                                      <option id="ember2092" value="FedEx_Box_Large_2" class="ember-view x-option">FedEx® Large Box -L2 (11.3 x 8.8 x 7.8 in)</option>
                                      <option id="ember2094" value="FedEx_Pak_1" class="ember-view x-option">FedEx® Large Pak (15.5 x 12.0 x 0.8 in)</option>
                                      <option id="ember2096" value="FedEx_Box_Medium_1" class="ember-view x-option">FedEx® Medium Box -M1 (13.3 x 11.5 x 2.4 in)</option>
                                      <option id="ember2098" value="FedEx_Box_Medium_2" class="ember-view x-option">FedEx® Medium Box -M2 (11.3 x 8.8 x 4.4 in)</option>
                                      <option id="ember2100" value="FedEx_Padded_Pak" class="ember-view x-option">FedEx® Padded Pak (11.8 x 14.8 x 2.0 in)</option>
                                      <option id="ember2102" value="FedEx_Box_Small_1" class="ember-view x-option">FedEx® Small Box -S1 (12.4 x 10.9 x 1.5 in)</option>
                                      <option id="ember2104" value="FedEx_Box_Small_2" class="ember-view x-option">FedEx® Small Box -S2 (11.3 x 8.8 x 4.4 in)</option>
                                      <option id="ember2106" value="FedEx_Pak_2" class="ember-view x-option">FedEx® Small Pak (12.8 x 10.3 x 0.8 in)</option>
                                      <option id="ember2108" value="FedEx_Tube" class="ember-view x-option">FedEx® Tube (38.0 x 6.0 x 6.0 in)</option>
                                      </optgroup>
                                  }

                                  {this.state.hasUPS &&
                                        <optgroup label="UPS">
                                          <option id="ember2111" value="UPS_Box_10kg" class="ember-view x-option">Box 10kg (410.0 x 335.0 x 265.0 mm)
                                          </option><option id="ember2113" value="UPS_Box_25kg" class="ember-view x-option">Box 25kg (484.0 x 433.0 x 350.0 mm)
                                          </option><option id="ember2115" value="UPS_MI_BPM" class="ember-view x-option">BPM -Mail Innovations (0 x 0 x 0 in)
                                          </option><option id="ember2117" value="UPS_MI_BPM_Flat" class="ember-view x-option">BPM Flat -Mail Innovations (0 x 0 x 0 in)
                                          </option><option id="ember2119" value="UPS_MI_BPM_Parcel" class="ember-view x-option">BPM Parcel -Mail Innovations (0 x 0 x 0 in)
                                          </option><option id="ember2121" value="UPS_Express_Box" class="ember-view x-option">Express Box (460.0 x 315.0 x 95.0 mm)
                                          </option><option id="ember2123" value="UPS_Express_Box_Large" class="ember-view x-option">Express Box Large (18.0 x 13.0 x 3.0 in)
                                          </option><option id="ember2125" value="UPS_Express_Box_Medium" class="ember-view x-option">Express Box Medium (15.0 x 11.0 x 3.0 in)
                                          </option><option id="ember2127" value="UPS_Express_Box_Small" class="ember-view x-option">Express Box Small (13.0 x 11.0 x 2.0 in)
                                          </option><option id="ember2129" value="UPS_Express_Envelope" class="ember-view x-option">Express Envelope (12.5 x 9.5 x 2.0 in)
                                          </option><option id="ember2131" value="UPS_Express_Hard_Pak" class="ember-view x-option">Express Hard Pak (14.8 x 11.5 x 2.0 in)
                                          </option><option id="ember2133" value="UPS_Express_Legal_Envelope" class="ember-view x-option">Express Legal Envelope (15.0 x 9.5 x 2.0 in)
                                          </option><option id="ember2135" value="UPS_Express_Pak" class="ember-view x-option">Express Pak (16.0 x 12.8 x 2.0 in)
                                          </option><option id="ember2137" value="UPS_Express_Tube" class="ember-view x-option">Express Tube (970.0 x 190.0 x 165.0 mm)
                                          </option><option id="ember2139" value="UPS_MI_First_Class" class="ember-view x-option">First Class -Mail Innovations (0 x 0 x 0 in)
                                          </option><option id="ember2141" value="UPS_MI_Flat" class="ember-view x-option">Flat -Mail Innovations (0 x 0 x 0 in)
                                          </option><option id="ember2143" value="UPS_MI_Irregular" class="ember-view x-option">Irregular -Mail Innovations (0 x 0 x 0 in)
                                          </option><option id="ember2145" value="UPS_Laboratory_Pak" class="ember-view x-option">Laboratory Pak (17.3 x 12.8 x 2.0 in)
                                          </option><option id="ember2147" value="UPS_MI_Machinable" class="ember-view x-option">Machinable -Mail Innovations (0 x 0 x 0 in)
                                          </option><option id="ember2149" value="UPS_MI_MEDIA_MAIL" class="ember-view x-option">Media Mail -Mail Innovations (0 x 0 x 0 in)
                                          </option><option id="ember2151" value="UPS_Pad_Pak" class="ember-view x-option">Pad Pak (14.8 x 11.0 x 2.0 in)
                                          </option><option id="ember2153" value="UPS_Pallet" class="ember-view x-option">Pallet (120.0 x 80.0 x 200.0 cm)
                                          </option><option id="ember2155" value="UPS_MI_Parcel" class="ember-view x-option">Parcel -Mail Innovations (0 x 0 x 0 in)
                                          </option><option id="ember2157" value="UPS_MI_Parcel_Post" class="ember-view x-option">Parcel Post -Mail Innovations (0 x 0 x 0 in)
                                          </option><option id="ember2159" value="UPS_MI_Priority" class="ember-view x-option">Priority -Mail Innovations(0 x 0 x 0 in)
                                          </option><option id="ember2161" value="UPS_MI_Standard_Flat" class="ember-view x-option">Standard Flat -Mail Innovations (0 x 0 x 0 in)
                                          </option>
                                        </optgroup>
                                      }


                                      {this.state.hasUSPS &&
                                        <optgroup label="USPS">
                                        <option id="ember2164" value="USPS_APOFlatRateBox" class="ember-view x-option">APO/FPO/DPO Flat Rate Box (12.5 x 12.5 x 6.0 in)
                                        </option><option id="ember2166" value="USPS_Card" class="ember-view x-option">Card (6.0 x 4.3 x 0.0 in)
                                        </option><option id="ember2168" value="USPS_FlatRateCardboardEnvelope" class="ember-view x-option">Flat Rate Cardboard Envelope (12.5 x 9.5 x 0.8 in)
                                        </option><option id="ember2170" value="USPS_FlatRateEnvelope" class="ember-view x-option">Flat Rate Envelope (12.5 x 9.5 x 0.8 in)
                                        </option><option id="ember2172" value="USPS_FlatRateGiftCardEnvelope" class="ember-view x-option">Flat Rate Gift Card Envelope (10.0 x 7.0 x 0.8 in)
                                        </option><option id="ember2174" value="USPS_LargeVideoFlatRateBox" class="ember-view x-option">Flat Rate Large Video Box -Int'l only (9.6 x 6.4 x 2.2 in)
                                        </option><option id="ember2176" value="USPS_FlatRateLegalEnvelope" class="ember-view x-option">Flat Rate Legal Envelope (15.0 x 9.5 x 0.8 in)
                                        </option><option id="ember2178" value="USPS_FlatRatePaddedEnvelope" class="ember-view x-option">Flat Rate Padded Envelope (12.5 x 9.5 x 1.0 in)
                                        </option><option id="ember2180" value="USPS_FlatRateWindowEnvelope" class="ember-view x-option">Flat Rate Window Envelope (10.0 x 5.0 x 0.8 in)
                                        </option><option id="ember2182" value="USPS_IrregularParcel" class="ember-view x-option">Irregular Parcel (4.0 x 4.0 x 4.0 in)
                                        </option><option id="ember2184" value="USPS_LargeFlatRateBoardGameBox" class="ember-view x-option">Large Flat Rate Board Game Box (24.1 x 11.9 x 3.1 in)
                                        </option><option id="ember2186" value="USPS_LargeFlatRateBox" class="ember-view x-option">Large Flat Rate Box (12.3 x 12.3 x 6.0 in)
                                        </option><option id="ember2188" value="USPS_MediumFlatRateBox1" class="ember-view x-option">Medium Flat Rate Box 1 (11.3 x 8.8 x 6.0 in)
                                        </option><option id="ember2190" value="USPS_MediumFlatRateBox2" class="ember-view x-option">Medium Flat Rate Box 2 (14.0 x 12.0 x 3.5 in)
                                        </option><option id="ember2200" value="USPS_SmallFlatRateBox" class="ember-view x-option">Small Flat Rate Box (8.7 x 5.4 x 1.8 in)
                                        </option><option id="ember2202" value="USPS_SmallFlatRateEnvelope" class="ember-view x-option">Small Flat Rate Envelope (10.0 x 6.0 x 0.8 in)
                                        </option><option id="ember2204" value="USPS_SoftPack" class="ember-view x-option">Soft Pack (0 x 0 x 0 in)
                                        </option>                            </optgroup>
                                      }
                                 </select>   

              </div>
            </div>

          

            <div className='form-row'>
                    <div className='col-4'>
                        <label htmlFor="shippingPostalCode" className='text-danger'><b>Length (inches):</b></label>
                            <input
                            disabled={this.state.disabled}
                            type="number"
                            onChange={this.handleInputChange}
                            name="lengthInInches"
                            className="form-control"
                            placeholder=""
                            keyboard="numeric"

                            value= {this.state.lengthInInches}
                            />   
                        </div>
                      <div className='col-4'>
                        <label htmlFor="shippingPostalCode" className='text-danger'><b>Width (inches):</b></label>
                        <input
                        disabled={this.state.disabled}
                        type="number"
                        keyboard="numeric"
                        onChange={this.handleInputChange}
                        name="widthInInches"
                        className="form-control"
                        placeholder=""

                        value= {this.state.widthInInches}
                        />   
                    </div>
                    <div className='col-4'>
                        <label htmlFor="shippingPostalCode" className='text-danger'><b>Height (inches):</b></label>
                        <input
                        disabled={this.state.disabled}
                        type="number"
                        onChange={this.handleInputChange}
                        name="heightInInches"
                        className="form-control"
                        placeholder=""
                        keyboard="numeric"

                        value= {this.state.heightInInches}
                        />   
                      </div>
                    </div>   
                    <div className='form-row'>   
                       <div className='col-4'>
                        <label htmlFor="weightInLbs" className='text-danger'><b>Weight (Lbs):</b></label>
                        <input
                        disabled={this.state.disabled}
                        type="number"
                        onChange={this.handleInputChange}
                        name="weightInLbs"
                        className="form-control"
                        placeholder=""
                        keyboard="numeric"

                        value= {this.state.weightInLbs}
                        />   
                    </div>
                    <div className='col-4'>
                    <label htmlFor="shippingPostalCode" className='text-danger'><b>Weight (ounces):</b></label>
                        <input
                        disabled={this.state.disabled}
                        type="number"
                        onChange={this.handleInputChange}
                        name="weightInOunces"
                        className="form-control"
                        placeholder=""
                        keyboard="numeric"

                        value= {this.state.weightInOunces}
                        />   
                    </div>
                  {
                   /* <div className='col-4'>
                    <label htmlFor="valueAmount" className='text-primary'><b>Value($):</b></label>
                        <input
                        disabled={this.state.disabled}
                        type="number"
                        onChange={this.handleInputChange}
                        name="valueAmount"
                        className="form-control"
                        placeholder=""
                        keyboard="numeric"

                        value= {this.state.valueAmount}
                        />   
                    </div>
                    */
                  }
                  </div>
                  <div className='form-row'>   
                       <div className='col-6'>
                        <label htmlFor="insuranceAmt" className='text-primary'> Insurance:</label>
                        <input
                        disabled={this.state.disabled}
                        type="number"
                        onChange={this.handleInputChange}
                        name="insuranceAmt"
                        className="form-control"
                        placeholder=""
                        keyboard="numeric"

                        value= {this.state.insuranceAmt}
                        />   
                    </div>
                  
                    
                    <div className='col-6'>
                        <label htmlFor="additionalPackingFee" className='text-primary'>Add'l Pack Fee:</label>
                        <input
                        disabled={this.state.disabled}
                        type="number"
                        onChange={this.handleInputChange}
                        name="additionalPackingFee"
                        className="form-control"
                        placeholder=""
                        keyboard="numeric"

                        value= {this.state.additionalPackingFee}
                        />   
                    </div>
                     
                    


                    </div>
          <br/>
          <hr/>
           <div className='form-row'>
         
                 

             <div className='col-4'>
                    <button
                    disabled={this.state.disabled || (this.state.id===-1)}
                    className="btn btn-outline-info btn-sm"
                    onClick={() => {this.toStep1()}}>
                    Back
                    </button>
             </div>
             <div className='col-4 text-center'>
                      <button
                      disabled={this.state.disabled || (this.state.id===-1)}
                      className="btn btn-outline-primary btn-sm"
                      onClick={() => {this.closeWizard()}}>
                      Close
                      </button>
               
                  </div>
             <div className='col-4 text-right'>
             <button
                    disabled={this.state.disabled || (this.state.id===-1)}
                    className="btn btn-outline-success btn-sm"
                    onClick={() => {this.toStep3()}}>
                    Next
                    </button>
             
             </div>

             </div>

            </div>
        )
    }

    // show the rate selected for the infroom mode
    renderStepFourSummary=()=>{

        // Show the email confirm for guest
        if (this.state.billTypeCode==='house'){
            return (

                <div>
                    <h5> Shipping Selection :</h5>
                    <h6> This is the amount to charge to the folio </h6>
                    <div className='form-row'>
                        <div className='col-4'>
                            <img src={this.state.selectedRate.provider_image_75} alt='Provider'/>
                        </div>
                        <div className='col-4'>
                            <p className="text-info text-center"> {(this.state.selectedRate.servicelevel) ? this.state.selectedRate.servicelevel.name :this.state.selectedRate.duration_terms} </p>
                        </div>
                        <div className='col-4'>
                            <p className="text-primary"> {'$' + this.state.selectedRate.amount} </p>
                        </div>
                    </div> 
                </div>

            )
        }else{
            return (
                <div>
                   
                <div className='form-row'>
                    <div className='col-12'>
                    <h5> Confirmation : </h5>
                    <p className="text-primary">If this information is correct your ready to send! click "Send Shipping Request To Guest below to continue"</p>
                    </div>
                </div>
            </div>
            )
        }
        //


    }
    renderStep4BackButton=()=>{
          // Show the email confirm for guest
          if (this.state.billTypeCode==='house'){
            return (
           
            <button
            disabled={this.state.disabled || (this.state.id===-1)}
            className="btn btn-outline-info btn-sm"
            onClick={() => {this.toShippingOptions()}}>
            Back
            </button>
            )

          }else{
              return(
           
                <button
                disabled={this.state.disabled || (this.state.id===-1)}
                className="btn btn-outline-info btn-sm"
                onClick={() => {this.toStep3()}}>
                Back
                </button>
            )
          }
    }

    



    renderStep4PurchaseButton=()=>{
        // Show the email confirm for guest
        if (this.state.billTypeCode==='house'){
            return (
                <button
                disabled={this.state.disabled || (this.state.id===-1)|| (this.state.selectedRate===undefined)}
                className="btn btn-outline-success btn-sm"
                onClick={() => {this.purchase()}}>
                Purchase Shipping Label Now
                </button>
        
            )

        }else{
            return(
                <button
                disabled={this.state.disabled || (this.state.id===-1)}
                className="btn btn-success "
                onClick={() => {this.toStep5()}}>
                Send Shipping Request
                </button>
            
            )
        }
    }

    renderCellPhone=()=>{
      if (this.state.billTypeCode=== 'house'){
        return (
          null
        )
      }else{
        return (
          <div>
              <div className='form-row'>
              <div className='col-6'>
                  <h5>Cell Phone (optional):</h5>
              </div>
              <div className='col-6'>
                                <input
                                  disabled={this.state.disabled}
                                  
                                  onChange={this.handleInputChange}
                                  name="smsphonenumber"
                                  className="form-control"
                                  placeholder=""
                                  value= {this.state.smsphonenumber}
                                />
            
              </div>
          </div> 
          <div className='form-row'>
                <div className='col-12'>
                <small>Enter a cell phone number to have the shipping request texted</small>
              </div>
        </div>
       </div>
        )
      }
    }
    // Summary
    renderStepFour=()=>{
      
        return(
           
            <div className="alert alert-dismissible alert-secondary" style={{width:'700px', height:'600px'}}>
            <div className="row">
                  <div className='col-12'>
                      <p class="text-info"><b>Verify the shipping information is correct:</b> </p>
                     
                   </div>
           </div>   

          <div className='form-row alert alert-success'>
              <div className='col-6'>
              <h5> FROM : </h5>
              <p className="text-primary"><b>{this.state.name}</b> <br/>
              {this.state.fromAddress + ' ' +this.state.fromAddress2} <br/>
              {this.state.fromCity + ' ' +this.state.fromState + '. ' + this.state.fromPostalCode + ' ' + this.state.fromCountry}</p>
             

              </div>
              <div className='col-6'>
              <h5> TO : </h5>
              <p className="text-primary"><b>{this.state.firstName +  ' ' + this.state.lastName} </b><br/>
             {this.state.shippingAddress + ' ' +this.state.shippingAddress2} 
              {this.state.shippingCity + ' ' +this.state.shippingState + '. ' + this.state.shippingPostalCode + ' ' + this.state.shippingCountry}</p>
             

              </div>
          </div>
          <div className='form-row'>
              <div className='col-6'>
                <h5> Dimensions : </h5>
                <p className="text-success"><b>{  this.state.lengthInInches + ' X ' + this.state.widthInInches +  ' X ' + this.state.heightInInches +  '  Weight:' + this.state.weightInLbs + 'lbs. ' + this.state.weightInOunces + ' oz.'} </b></p>
              </div>
              <div className='col-6'>
                <h5> Email : </h5>
                <p className="text-info"><b>{  this.state.email} </b></p>
              </div>
          </div>
          
          {this.state.enableFeeOverride && 
            <div>
                <div className='form-row'>
              
                            <div className='col-6 ' style={{justifyContent:'flex-start', alignItems:'center'}}>
                                <label htmlFor="feeOverrideAmount" className='text-primary'><h5>Handling Fee:</h5></label>
                            </div>
                            <div className='col-4'>
                                <input
                                disabled={!this.state.enableFeeOverride}
                                type="number"
                                onChange={this.handleInputChange}
                                name="feeOverrideAmount"
                                className="form-control"
                                placeholder=""
                                keyboard="numeric"

                                value= {this.state.feeOverrideAmount}
                                />
                                </div>
                             
                        
                  </div>
                  <div className='form-row'>
                  <div className='col-12'>
                              <small>If your account is configured to enable shipping overrides, enter the fee here.  This is the fee BOUNTE will charge and split with your account.</small>
                              </div>
                    </div>
              </div>
    }
        
           
        <hr/>
        {this.renderCellPhone()}

   
         <hr/>
         {this.renderETipSection()}
        <br/>
         <div className='form-row'>
                <div className='col-3 text-left'>
                {this.renderStep4BackButton()}
              </div>
              <div className='col-3 text-center'>
                    <button
                    disabled={this.state.disabled || (this.state.id===-1)}
                    className="btn btn-outline-primary btn-sm"
                    onClick={() => {this.closeWizard()}}>
                    Close
                    </button>
             
                </div>
              <div className='col-6 text-right'>
             
              {this.renderStep4PurchaseButton()}
              </div>
              



         </div>

         </div>
       
        )
    }


    // Summary
    renderStepFive=()=>{
        return(
            <div className="alert alert-dismissible alert-secondary" style={{width:'600px', height:'600px'}}>
                <div className='form-row'>
                    <div className='col-12' style={{textAlign:'center'}}>
                        <img src="../success.png" style={{width:'200px', height:'250px'}} alt=''/>
                        <br/>
                        <h5> Your Shipping Request Was Successfully Sent </h5>
                        <br/>
                        <p class="text-success">Check the BOUNTE Dashboard for notification when guest completes the shipping label purchase </p>
                    </div>
                </div>

               
            </div>

       
        )
    }
    renderStepSix=()=>{
      return(
        <div className="alert alert-dismissible alert-secondary" style={{width:'600px', height:'600px'}}>
            <div className='form-row'>
                <div className='col-12' style={{textAlign:'center'}}>
                    <img src="../success.png" style={{width:'200px', height:'250px'}} alt=''/>
                    <br/>
                    <h5> Your Shipping Purchase is complete.</h5>
                    <br/>
                    <h5> An email with the tracking/shipping information has been sent to the guest.</h5>

                    <p className="text-success">Use ShipCentral link to cancel, refund and track shipments. </p>
                </div>
            </div>

           
        </div>

   
    )
    }

//shippoErrors

    renderLoadingAndRatesTable=()=>{
          const selectRow = {
              mode: 'radio',
              clickToSelect: true,
              style: { background: '#93E9BE' },
              selected:this.state.selectedRows,
          };

           if (this.state.loading){
              return ( 
                    <h2> Retrieving Rates...</h2>
                );
           }else{
            return(
              <div>

            
                <BootstrapTable
                    keyField='object_id'
                    style={{height:'400px',overflowY: 'auto',lineHeight:'50px', padding:'3px'}}
                    data={ (this.state.shippoRateResults && this.state.shippoRateResults.rates) ? this.state.shippoRateResults.rates : [] } 
                    columns={ columns } 
                    className="table-sm"
                    height='250'
                   
                    hover
                    condensed
                    
                    rowEvents={this.rowEvents}
                    selectRow={selectRow}
                        />
                   {
                   //(this.state.shippoMessages && this.state.shippoMessages.length>0) ? this.renderShippoMessages() : null 
                    }   
                   {this.renderShippoErrors()}
                </div>
            );

           }
    }

    renderShippoErrors =()=>{
        if (this.state.shippoErrors && this.state.shippoErrors.length>0){
          return(
            <div>
            {this.state.shippoErrors.map(item=>{
              return(<p className='text-danger'>{item}</p>)
            })}
            </div>
          )
        }
    }

    renderShippoMessages=()=>{
    

      return(
            <BootstrapTable
                    keyField='object_id'
                    style={{height:'50px', overflowY: 'auto',lineHeight:'20px', padding:'3px'}}
                    data={ (this.state.shippoMessages) ? this.state.shippoMessages : [] } 
                    columns={ [
                       
                        {dataField: 'source', text: 'source' },
                        {dataField: 'text', text: 'Message' },
                    ]}
                    className="table-sm"
                    height='50'
                    striped
                    hover
                    condensed
                  

                        /> 
        )
    }
/************************************************************************************************************************************************************************************
Step: 6 
Display shipping options
*************************************************************************************************************************************************************************************/
    renderShippingOptions=()=>{
        return(
            <div className="alert alert-dismissible alert-secondary" >
            <div className="row" style={{width:'700px', height:'600px', overflow: 'auto'}}>
                  <div className='col-12' style={{textAlign:'center'}}>
                      <p className="text-info"> Select Shipping Option : Click a row to select rate </p>
                            
                               
                    {this.renderLoadingAndRatesTable()}
                    <br/>
                    
                   </div>
                  
           </div> 
           <div className='form-row'>
              <div className='col-4 text-left'>
                      <button
                      disabled={this.state.disabled || (this.state.id===-1)}
                      className="btn btn-outline-info btn-sm"
                      onClick={() => {this.toStep3()}}>
                      Back
                      </button>
              </div>
              <div className='col-4 text-center'>
                  <p className='text-info'>Selected: {this.state.selectedShipperName}</p>
              </div>
              <div className='col-4 text-right'>
              <button
                      disabled={this.state.selectedRate.amount===undefined}
                      className="btn btn-outline-info btn-sm"
                      onClick={() => {this.toStep4()}}>
                     Next
                      </button>
              
              </div>
              



         </div>

           </div> 
        )


    }



/************************************************************************************************************************************************************************************
renderStepThree
*************************************************************************************************************************************************************************************/
    renderStepThree=()=>{

        return(
            <div className="alert alert-dismissible alert-secondary" style={{width:'700px', height:'600px'}}>
            <div className="row">
                  <div className='col-12' style={{textAlign:'center'}}>
                      <p className="text-info"> International Shipping Use Only: *CUSTOMS DECLARATION* </p>
                     
                   </div>
           </div>   
           <div className="row">
                  <div className='col-12' style={{textAlign:'center'}}>
                      <p className="text-muted"> Note: You must include one signed original and two copies of a commercial invoice along with your label, unless shipping with USPS. </p>
                     
                   </div>
           </div>  


<div className='form-row'>
              <div className='col-12'>
              <label htmlFor="customDescription" className='text-danger'>Item Description ** Be as descriptive as possible or it might be rejected ** :</label>
                              <input
                                disabled={!this.state.isInternational}
                                type="text"
                                onChange={this.handleInputChange}
                                name="customDescription"
                                className="form-control"
                                placeholder=""
                                value= {this.state.customDescription}
                              />
              </div>

              </div>


           <div className='form-row'>
              <div className='col-6'>
                    <label htmlFor="shippingCountry" className='text-primary'> Type Of Content (required):</label>
                                          <select
                                            disabled={!this.state.isInternational}
                                            type="text"
                                            onChange={this.handleInputChange}
                                            name="typeOfContent"
                                            className="custom-select"
                                            placeholder=""
                                            value= {this.state.typeOfContent}
                                          > 
                                          {typeOfContent.map(item => (
                                            <option key={item} value={item}>
                                              {item}
                                            </option>
                                          ))}
                                          </select>   

   
                </div>
                <div className='col-6'>
                            <label htmlFor="lastName" className='text-primary'>Signing Person(required) :</label>
                              <input
                                disabled={!this.state.isInternational}
                                type="text"
                                onChange={this.handleInputChange}
                                name="certifiedSigner"
                                className="form-control"
                                placeholder=""
                                value= {this.state.certifiedSigner}
                              />
              </div>

           </div>  

            <div className='form-row'>
              <div className='col-3'>
              <label htmlFor="shippingPostalCode"> QTY:</label>
                        <input
                        disabled={!this.state.isInternational}
                        type="number"
                        onChange={this.handleInputChange}
                        name="customQuantity"
                        className="form-control"
                        placeholder=""
                        keyboard="numeric"

                        value= {this.state.customQuantity}
                        />   
              </div>
              <div className='col-3'>
              <label htmlFor="shippingPostalCode"> Value:</label>
                        <input
                        disabled={!this.state.isInternational}
                        type="number"
                        onChange={this.handleInputChange}
                        name="customValue"
                        className="form-control"
                        placeholder=""
                        keyboard="numeric"

                        value= {this.state.customValue}
                        />   
              </div>
              <div className='col-3'>
                    <label htmlFor="ccytype" className='text-primary'> Currency:</label>
                                          <select
                                            disabled={!this.state.isInternational}
                                            type="text"
                                            onChange={this.handleInputChange}
                                            name="customCcy"
                                            className="custom-select"
                                            placeholder=""
                                            value= {this.state.customCcy}
                                          > 
                                          {currencyCodes.map(item => (
                                            <option key={item} value={item}>
                                              {item}
                                            </option>
                                          ))}
                                          </select>   

   
                </div>
              </div>
              <div className='form-row'>
                 <div className='col-6'>
                    <label htmlFor="customCountryOfOrigin" className='text-primary'> Country Of Origin (required):</label>
                                          <select
                                            disabled={!this.state.isInternational}
                                            type="text"
                                            onChange={this.handleInputChange}
                                            name="customCountryOfOrigin"
                                            className="custom-select"
                                            placeholder=""
                                            value= {this.state.customCountryOfOrigin}
                                          > 
                                          {isoCountries.map(item => (
                                            <option key={item.ccode} value={item.ccode}>
                                              {item.cname}
                                            </option>
                                          ))}
                                          </select>   

                </div>

                

             </div>
             <br/>
           <div className='form-row'>
              <div className='col-4 text-left'>
                      <button
                      disabled={this.state.disabled || (this.state.id===-1)}
                      className="btn btn-outline-info btn-sm"
                      onClick={() => {this.toStep2()}}>
                      Back
                      </button>
              </div>
              <div className='col-4 text-center'>
                      <button
                      disabled={this.state.disabled || (this.state.id===-1)}
                      className="btn btn-outline-primary btn-sm"
                      onClick={() => {this.closeWizard()}}>
                      Close
                      </button>
               
                  </div>
              <div className='col-4 text-right'>
                    {this.renderNextButtonForInternational()}
              
              </div>

         </div>


          </div>



        )



    }

    toShippingOptions=()=>{
        // Save shipment
        //console.log('shipping options loading....');
        //alert('go');
        this.getShippingOptions();
        // retrieve ID


        // load content

        
        
        
        
        
        this.setState({
            displayStep3:false,
            displayStep4:false,
            displayShippingOptions:true
        })
    }


    renderNextButtonForInternational=()=>{
        if (this.state.billTypeCode==='house'){
            return(
                <button
                disabled={this.state.disabled || (this.state.id===-1)}
                className="btn btn-outline-success btn-sm"
                onClick={() => {this.toShippingOptions()}}>
                    Display Shipping Options
                </button>
            )
        }else{
        return(
            <button
            disabled={this.state.disabled || (this.state.id===-1)}
            className="btn btn-outline-success btn-sm"
            onClick={() => {this.toStep4()}}>
                 Next
            </button>
            )
        }
    }

    renderToast=()=>{
      return <div>
          
          <ToastContainer position={ToastContainer.POSITION.TOP_RIGHT}  lightBackground store={ToastStore}/>
      </div>
    }
    
    render(){
        return (
            <div style={{marginTop:0}}>
            <div className="row table-info">
                <div className='col-12'>
                    <h4>Return Wizard  :  Step {this.state.currentStep} of 5</h4>
                </div>
            </div>
            
            {this.renderToast()}
             {(this.state.displayStep1)? this.renderStepOne() :  null  }
             {(this.state.displayStep2)? this.renderStepTwo() :  null  }
             {(this.state.displayStep3)? this.renderStepThree() :  null  }
             {(this.state.displayStep4)? this.renderStepFour() :  null  }
            {(this.state.displayStep5)? this.renderStepFive() :  null  }  
            {(this.state.displayStep6)? this.renderStepSix() :  null  }  

            {(this.state.displayShippingOptions)? this.renderShippingOptions() :  null  } 

                  
                </div>
        
            
        )
    }
}




export default withRouter(ReturnWizard2); 


const isoCountries = [
  {'ccode' : '', 'cname' : ''},

    {'ccode' : 'US', 'cname' : 'United States'},
    {'ccode' : 'AF', 'cname' : 'Afghanistan'},
    {'ccode' : 'AX', 'cname' : 'Aland Islands'},
    {'ccode' : 'AL', 'cname' : 'Albania'},
    {'ccode' : 'DZ', 'cname' : 'Algeria'},
    {'ccode' : 'AS', 'cname' : 'American Samoa'},
    {'ccode' : 'AD', 'cname' : 'Andorra'},
    {'ccode' : 'AO', 'cname' : 'Angola'},
    {'ccode' : 'AI', 'cname' : 'Anguilla'},
    {'ccode' : 'AQ', 'cname' : 'Antarctica'},
    {'ccode' : 'AG', 'cname' : 'Antigua And Barbuda'},
    {'ccode' : 'AR', 'cname' : 'Argentina'},
    {'ccode' : 'AM', 'cname' : 'Armenia'},
    {'ccode' : 'AW', 'cname' : 'Aruba'},
    {'ccode' : 'AU', 'cname' : 'Australia'},
    {'ccode' : 'AT', 'cname' : 'Austria'},
    {'ccode' : 'AZ', 'cname' : 'Azerbaijan'},
    {'ccode' : 'BS', 'cname' : 'Bahamas'},
    {'ccode' : 'BH', 'cname' : 'Bahrain'},
    {'ccode' : 'BD', 'cname' : 'Bangladesh'},
    {'ccode' : 'BB', 'cname' : 'Barbados'},
    {'ccode' : 'BY', 'cname' : 'Belarus'},
    {'ccode' : 'BE', 'cname' : 'Belgium'},
    {'ccode' : 'BZ', 'cname' : 'Belize'},
    {'ccode' : 'BJ', 'cname' : 'Benin'},
    {'ccode' : 'BM', 'cname' : 'Bermuda'},
    {'ccode' : 'BT', 'cname' : 'Bhutan'},
    {'ccode' : 'BO', 'cname' : 'Bolivia'},
    {'ccode' : 'BA', 'cname' : 'Bosnia And Herzegovina'},
    {'ccode' : 'BW', 'cname' : 'Botswana'},
    {'ccode' : 'BV', 'cname' : 'Bouvet Island'},
    {'ccode' : 'BR', 'cname' : 'Brazil'},
    {'ccode' : 'IO', 'cname' : 'British Indian Ocean Territory'},
    {'ccode' : 'BN', 'cname' : 'Brunei Darussalam'},
    {'ccode' : 'BG', 'cname' : 'Bulgaria'},
    {'ccode' : 'BF', 'cname' : 'Burkina Faso'},
    {'ccode' : 'BI', 'cname' : 'Burundi'},
    {'ccode' : 'KH', 'cname' : 'Cambodia'},
    {'ccode' : 'CM', 'cname' : 'Cameroon'},
    {'ccode' : 'CA', 'cname' : 'Canada'},
    {'ccode' : 'CV', 'cname' : 'Cape Verde'},
    {'ccode' : 'KY', 'cname' : 'Cayman Islands'},
    {'ccode' : 'CF', 'cname' : 'Central African Republic'},
    {'ccode' : 'TD', 'cname' : 'Chad'},
    {'ccode' : 'CL', 'cname' : 'Chile'},
    {'ccode' : 'CN', 'cname' : 'China'},
    {'ccode' : 'CX', 'cname' : 'Christmas Island'},
    {'ccode' : 'CC', 'cname' : 'Cocos (Keeling) Islands'},
    {'ccode' : 'CO', 'cname' : 'Colombia'},
    {'ccode' : 'KM', 'cname' : 'Comoros'},
    {'ccode' : 'CG', 'cname' : 'Congo'},
    {'ccode' : 'CD', 'cname' : 'Congo, Democratic Republic'},
    {'ccode' : 'CK', 'cname' : 'Cook Islands'},
    {'ccode' : 'CR', 'cname' : 'Costa Rica'},
    {'ccode' : 'CI', 'cname' : 'Cote D\'Ivoire'},
    {'ccode' : 'HR', 'cname' : 'Croatia'},
    {'ccode' : 'CU', 'cname' : 'Cuba'},
    {'ccode' : 'CY', 'cname' : 'Cyprus'},
    {'ccode' : 'CZ', 'cname' : 'Czech Republic'},
    {'ccode' : 'DK', 'cname' : 'Denmark'},
    {'ccode' : 'DJ', 'cname' : 'Djibouti'},
    {'ccode' : 'DM', 'cname' : 'Dominica'},
    {'ccode' : 'DO', 'cname' : 'Dominican Republic'},
    {'ccode' : 'EC', 'cname' : 'Ecuador'},
    {'ccode' : 'EG', 'cname' : 'Egypt'},
    {'ccode' : 'SV', 'cname' : 'El Salvador'},
    {'ccode' : 'GQ', 'cname' : 'Equatorial Guinea'},
    {'ccode' : 'ER', 'cname' : 'Eritrea'},
    {'ccode' : 'EE', 'cname' : 'Estonia'},
    {'ccode' : 'ET', 'cname' : 'Ethiopia'},
    {'ccode' : 'FK', 'cname' : 'Falkland Islands (Malvinas)'},
    {'ccode' : 'FO', 'cname' : 'Faroe Islands'},
    {'ccode' : 'FJ', 'cname' : 'Fiji'},
    {'ccode' : 'FI', 'cname' : 'Finland'},
    {'ccode' : 'FR', 'cname' : 'France'},
    {'ccode' : 'GF', 'cname' : 'French Guiana'},
    {'ccode' : 'PF', 'cname' : 'French Polynesia'},
    {'ccode' : 'TF', 'cname' : 'French Southern Territories'},
    {'ccode' : 'GA', 'cname' : 'Gabon'},
    {'ccode' : 'GM', 'cname' : 'Gambia'},
    {'ccode' : 'GE', 'cname' : 'Georgia'},
    {'ccode' : 'DE', 'cname' : 'Germany'},
    {'ccode' : 'GH', 'cname' : 'Ghana'},
    {'ccode' : 'GI', 'cname' : 'Gibraltar'},
    {'ccode' : 'GR', 'cname' : 'Greece'},
    {'ccode' : 'GL', 'cname' : 'Greenland'},
    {'ccode' : 'GD', 'cname' : 'Grenada'},
    {'ccode' : 'GP', 'cname' : 'Guadeloupe'},
    {'ccode' : 'GU', 'cname' : 'Guam'},
    {'ccode' : 'GT', 'cname' : 'Guatemala'},
    {'ccode' : 'GG', 'cname' : 'Guernsey'},
    {'ccode' : 'GN', 'cname' : 'Guinea'},
    {'ccode' : 'GW', 'cname' : 'Guinea-Bissau'},
    {'ccode' : 'GY', 'cname' : 'Guyana'},
    {'ccode' : 'HT', 'cname' : 'Haiti'},
    {'ccode' : 'HM', 'cname' : 'Heard Island & Mcdonald Islands'},
    {'ccode' : 'VA', 'cname' : 'Holy See (Vatican City State)'},
    {'ccode' : 'HN', 'cname' : 'Honduras'},
    {'ccode' : 'HK', 'cname' : 'Hong Kong'},
    {'ccode' : 'HU', 'cname' : 'Hungary'},
    {'ccode' : 'IS', 'cname' : 'Iceland'},
    {'ccode' : 'IN', 'cname' : 'India'},
    {'ccode' : 'ID', 'cname' : 'Indonesia'},
    {'ccode' : 'IR', 'cname' : 'Iran, Islamic Republic Of'},
    {'ccode' : 'IQ', 'cname' : 'Iraq'},
    {'ccode' : 'IE', 'cname' : 'Ireland'},
    {'ccode' : 'IM', 'cname' : 'Isle Of Man'},
    {'ccode' : 'IL', 'cname' : 'Israel'},
    {'ccode' : 'IT', 'cname' : 'Italy'},
    {'ccode' : 'JM', 'cname' : 'Jamaica'},
    {'ccode' : 'JP', 'cname' : 'Japan'},
    {'ccode' : 'JE', 'cname' : 'Jersey'},
    {'ccode' : 'JO', 'cname' : 'Jordan'},
    {'ccode' : 'KZ', 'cname' : 'Kazakhstan'},
    {'ccode' : 'KE', 'cname' : 'Kenya'},
    {'ccode' : 'KI', 'cname' : 'Kiribati'},
    {'ccode' : 'KR', 'cname' : 'Korea'},
    {'ccode' : 'KW', 'cname' : 'Kuwait'},
    {'ccode' : 'KG', 'cname' : 'Kyrgyzstan'},
    {'ccode' : 'LA', 'cname' : 'Lao People\'s Democratic Republic'},
    {'ccode' : 'LV', 'cname' : 'Latvia'},
    {'ccode' : 'LB', 'cname' : 'Lebanon'},
    {'ccode' : 'LS', 'cname' : 'Lesotho'},
    {'ccode' : 'LR', 'cname' : 'Liberia'},
    {'ccode' : 'LY', 'cname' : 'Libyan Arab Jamahiriya'},
    {'ccode' : 'LI', 'cname' : 'Liechtenstein'},
    {'ccode' : 'LT', 'cname' : 'Lithuania'},
    {'ccode' : 'LU', 'cname' : 'Luxembourg'},
    {'ccode' : 'MO', 'cname' : 'Macao'},
    {'ccode' : 'MK', 'cname' : 'Macedonia'},
    {'ccode' : 'MG', 'cname' : 'Madagascar'},
    {'ccode' : 'MW', 'cname' : 'Malawi'},
    {'ccode' : 'MY', 'cname' : 'Malaysia'},
    {'ccode' : 'MV', 'cname' : 'Maldives'},
    {'ccode' : 'ML', 'cname' : 'Mali'},
    {'ccode' : 'MT', 'cname' : 'Malta'},
    {'ccode' : 'MH', 'cname' : 'Marshall Islands'},
    {'ccode' : 'MQ', 'cname' : 'Martinique'},
    {'ccode' : 'MR', 'cname' : 'Mauritania'},
    {'ccode' : 'MU', 'cname' : 'Mauritius'},
    {'ccode' : 'YT', 'cname' : 'Mayotte'},
    {'ccode' : 'MX', 'cname' : 'Mexico'},
    {'ccode' : 'FM', 'cname' : 'Micronesia, Federated States Of'},
    {'ccode' : 'MD', 'cname' : 'Moldova'},
    {'ccode' : 'MC', 'cname' : 'Monaco'},
    {'ccode' : 'MN', 'cname' : 'Mongolia'},
    {'ccode' : 'ME', 'cname' : 'Montenegro'},
    {'ccode' : 'MS', 'cname' : 'Montserrat'},
    {'ccode' : 'MA', 'cname' : 'Morocco'},
    {'ccode' : 'MZ', 'cname' : 'Mozambique'},
    {'ccode' : 'MM', 'cname' : 'Myanmar'},
    {'ccode' : 'NA', 'cname' : 'Namibia'},
    {'ccode' : 'NR', 'cname' : 'Nauru'},
    {'ccode' : 'NP', 'cname' : 'Nepal'},
    {'ccode' : 'NL', 'cname' : 'Netherlands'},
    {'ccode' : 'AN', 'cname' : 'Netherlands Antilles'},
    {'ccode' : 'NC', 'cname' : 'New Caledonia'},
    {'ccode' : 'NZ', 'cname' : 'New Zealand'},
    {'ccode' : 'NI', 'cname' : 'Nicaragua'},
    {'ccode' : 'NE', 'cname' : 'Niger'},
    {'ccode' : 'NG', 'cname' : 'Nigeria'},
    {'ccode' : 'NU', 'cname' : 'Niue'},
    {'ccode' : 'NF', 'cname' : 'Norfolk Island'},
    {'ccode' : 'MP', 'cname' : 'Northern Mariana Islands'},
    {'ccode' : 'NO', 'cname' : 'Norway'},
    {'ccode' : 'OM', 'cname' : 'Oman'},
    {'ccode' : 'PK', 'cname' : 'Pakistan'},
    {'ccode' : 'PW', 'cname' : 'Palau'},
    {'ccode' : 'PS', 'cname' : 'Palestinian Territory, Occupied'},
    {'ccode' : 'PA', 'cname' : 'Panama'},
    {'ccode' : 'PG', 'cname' : 'Papua New Guinea'},
    {'ccode' : 'PY', 'cname' : 'Paraguay'},
    {'ccode' : 'PE', 'cname' : 'Peru'},
    {'ccode' : 'PH', 'cname' : 'Philippines'},
    {'ccode' : 'PN', 'cname' : 'Pitcairn'},
    {'ccode' : 'PL', 'cname' : 'Poland'},
    {'ccode' : 'PT', 'cname' : 'Portugal'},
    {'ccode' : 'PR', 'cname' : 'Puerto Rico'},
    {'ccode' : 'QA', 'cname' : 'Qatar'},
    {'ccode' : 'RE', 'cname' : 'Reunion'},
    {'ccode' : 'RO', 'cname' : 'Romania'},
    {'ccode' : 'RU', 'cname' : 'Russian Federation'},
    {'ccode' : 'RW', 'cname' : 'Rwanda'},
    {'ccode' : 'BL', 'cname' : 'Saint Barthelemy'},
    {'ccode' : 'SH', 'cname' : 'Saint Helena'},
    {'ccode' : 'KN', 'cname' : 'Saint Kitts And Nevis'},
    {'ccode' : 'LC', 'cname' : 'Saint Lucia'},
    {'ccode' : 'MF', 'cname' : 'Saint Martin'},
    {'ccode' : 'PM', 'cname' : 'Saint Pierre And Miquelon'},
    {'ccode' : 'VC', 'cname' : 'Saint Vincent And Grenadines'},
    {'ccode' : 'WS', 'cname' : 'Samoa'},
    {'ccode' : 'SM', 'cname' : 'San Marino'},
    {'ccode' : 'ST', 'cname' : 'Sao Tome And Principe'},
    {'ccode' : 'SA', 'cname' : 'Saudi Arabia'},
    {'ccode' : 'SN', 'cname' : 'Senegal'},
    {'ccode' : 'RS', 'cname' : 'Serbia'},
    {'ccode' : 'SC', 'cname' : 'Seychelles'},
    {'ccode' : 'SL', 'cname' : 'Sierra Leone'},
    {'ccode' : 'SG', 'cname' : 'Singapore'},
    {'ccode' : 'SK', 'cname' : 'Slovakia'},
    {'ccode' : 'SI', 'cname' : 'Slovenia'},
    {'ccode' : 'SB', 'cname' : 'Solomon Islands'},
    {'ccode' : 'SO', 'cname' : 'Somalia'},
    {'ccode' : 'ZA', 'cname' : 'South Africa'},
    {'ccode' : 'GS', 'cname' : 'South Georgia And Sandwich Isl.'},
    {'ccode' : 'ES', 'cname' : 'Spain'},
    {'ccode' : 'LK', 'cname' : 'Sri Lanka'},
    {'ccode' : 'SD', 'cname' : 'Sudan'},
    {'ccode' : 'SR', 'cname' : 'Suriname'},
    {'ccode' : 'SJ', 'cname' : 'Svalbard And Jan Mayen'},
    {'ccode' : 'SZ', 'cname' : 'Swaziland'},
    {'ccode' : 'SE', 'cname' : 'Sweden'},
    {'ccode' : 'CH', 'cname' : 'Switzerland'},
    {'ccode' : 'SY', 'cname' : 'Syrian Arab Republic'},
    {'ccode' : 'TW', 'cname' : 'Taiwan'},
    {'ccode' : 'TJ', 'cname' : 'Tajikistan'},
    {'ccode' : 'TZ', 'cname' : 'Tanzania'},
    {'ccode' : 'TH', 'cname' : 'Thailand'},
    {'ccode' : 'TL', 'cname' : 'Timor-Leste'},
    {'ccode' : 'TG', 'cname' : 'Togo'},
    {'ccode' : 'TK', 'cname' : 'Tokelau'},
    {'ccode' : 'TO', 'cname' : 'Tonga'},
    {'ccode' : 'TT', 'cname' : 'Trinidad And Tobago'},
    {'ccode' : 'TN', 'cname' : 'Tunisia'},
    {'ccode' : 'TR', 'cname' : 'Turkey'},
    {'ccode' : 'TM', 'cname' : 'Turkmenistan'},
    {'ccode' : 'TC', 'cname' : 'Turks And Caicos Islands'},
    {'ccode' : 'TV', 'cname' : 'Tuvalu'},
    {'ccode' : 'UG', 'cname' : 'Uganda'},
    {'ccode' : 'UA', 'cname' : 'Ukraine'},
    {'ccode' : 'AE', 'cname' : 'United Arab Emirates'},
    {'ccode' : 'GB', 'cname' : 'United Kingdom'},
   
    {'ccode' : 'UM', 'cname' : 'United States Outlying Islands'},
    {'ccode' : 'UY', 'cname' : 'Uruguay'},
    {'ccode' : 'UZ', 'cname' : 'Uzbekistan'},
    {'ccode' : 'VU', 'cname' : 'Vanuatu'},
    {'ccode' : 'VE', 'cname' : 'Venezuela'},
    {'ccode' : 'VN', 'cname' : 'Viet Nam'},
    {'ccode' : 'VG', 'cname' : 'Virgin Islands, British'},
    {'ccode' : 'VI', 'cname' : 'Virgin Islands, U.S.'},
    {'ccode' : 'WF', 'cname' : 'Wallis And Futuna'},
    {'ccode' : 'EH', 'cname' : 'Western Sahara'},
    {'ccode' : 'YE', 'cname' : 'Yemen'},
    {'ccode' : 'ZM', 'cname' : 'Zambia'},
    {'ccode' : 'ZW', 'cname' : 'Zimbabwe'}
  ];